import { render, staticRenderFns } from "./ActionNeededExpensesWidget.vue?vue&type=template&id=41fb75ed&scoped=true"
import script from "./ActionNeededExpensesWidget.vue?vue&type=script&lang=ts"
export * from "./ActionNeededExpensesWidget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fb75ed",
  null
  
)

export default component.exports